module.exports = __webpack_public_path__ + "static/media/pig.587201ad.png";